import React from 'react';

const Ayuda = () => {
    return (
        <h1>Ayuda</h1>
    );
}
 
export default Ayuda;